import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
// styles
import "../../../assets/saas/molecules/_brandstar-multiples.scss";
const MultipleRentersLogosComponent = (categoriesProps) => {
    const [rentersArray, setRentersArray] = useState([]);
    useEffect(() => {
        setRentersArray((prevRentersArray) => {
            // Map renters to an array of names and convert to lowercase
            const newRentersArray = categoriesProps.renters.map((renter) => renter.renterName.toLowerCase());
            // Use a Set to keep track of unique names
            const uniqueNamesSet = new Set([...newRentersArray]);
            // Convert the Set back to an array
            const uniqueNamesArray = Array.from(uniqueNamesSet);
            return uniqueNamesArray;
        });
    }, [categoriesProps.renters]);
    return (_jsxs("div", { className: "brandstar-multiples", children: [_jsx("div", { className: "brandstar-multiples__text", children: categoriesProps.t("delivery_by_results") }), _jsx("div", { className: "brandstar-multiples__logos", children: rentersArray.map((renter, index) => {
                    var _a, _b;
                    const logoSrc = (_b = (_a = categoriesProps.collection.find((collection) => collection.title.toLowerCase() === renter)) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.src;
                    return (_jsx("div", { className: "img_logo_cnt", children: logoSrc && (_jsx("img", { alt: "", className: "logo-brandstar-multiples", id: "img_logo_multiple_results" + index, src: logoSrc })) }, index));
                }) })] }));
};
export default MultipleRentersLogosComponent;
